<div class="profile-content">
  <div class="row">
    <div class="col-md-12">
      <div class="caption caption-md">
        <span class="caption-subject">Personal information </span>
      </div>
    </div>

    <form [formGroup]="myProfileForm" (ngSubmit)="submit()" class="contactus-forms">
      <div class="form-group">
        <label class="profile-label">Profile photo</label>
        <div class="row custom-wrapper">
          <div class="col-md-4">
            <div class="group-gap">
              <ng-container *ngrxLet="UserDetailsFacade.userProfileImage$ as userProfileImage">
                <div class="avatar-upload">
                  <div class="avatar-edit">
                    <input
                      type="file"
                      id="imageUpload"
                      accept="image/png, image/jpg, image/jpeg"
                      #fileInput
                      (change)="uploadFile($event, userProfileImage)"
                      formControlName="image"
                    />
                  </div>
                  <div class="avatar-preview">
                    <img
                      id="imagePreview"
                      [src]="
                        userProfileImage?.hasOwnProperty('imageThumb') &&
                        userProfileImage?.imageThumb
                          ? 'data:image/jpg;base64,' + userProfileImage.imageThumb
                          : profileImage
                      "
                    />
                    <i
                      class="fa fa-pencil pencil"
                      accept=".png, .jpg, .jpeg"
                      aria-hidden="true"
                      (click)="fileInput.click()"
                    ></i>
                  </div>
                </div>
                <div *ngIf="imageRequired">
                  <label class="text-required">File type must be png, jpg, jpeg</label>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <span class="caption-sub-subject">Edit your details below</span>

      <div class="row">
        <div class="form-group col-12 col-md-6 required">
          <piqet-angular-common-input
            formControlName="firstName"
            [control]="myProfileForm.get('firstName')"
            label="First name"
            placeholder="Enter first name"
            [maxLength]="50"
          >
          </piqet-angular-common-input>
        </div>

        <div class="form-group col-12 col-md-6 required">
          <piqet-angular-common-input
            formControlName="lastName"
            [control]="myProfileForm.get('lastName')"
            label="Last name"
            placeholder="Enter last name"
            [maxLength]="50"
          >
          </piqet-angular-common-input>
        </div>
        <div class="form-group col-12 col-md-6 required">
          <piqet-angular-common-input
            formControlName="email"
            [control]="myProfileForm.get('email')"
            label="Email"
            placeholder="Email"
            [maxLength]="150"
            [submitted]="submitted"
            [inputType]="'email'"
            (customBlur)="getEmailValidation()"
            (inputEvent)="changeEmail($event)"
            [errorMessages]="{
              required: 'The email field is required.',
              email: 'Invalid email address'
            }"
          >
          </piqet-angular-common-input>

          <div *ngIf="isEmailValid && !!currentEmail" class="input-error">
            <span
              *ngIf="
                myProfileForm.get('email')?.valid &&
                isEmailValid &&
                userPersonalData.userName !== myProfileForm.controls['email'].value
              "
            >
              {{ currentEmail }} is already taken.</span
            >
          </div>
        </div>
        <div class="form-group col-12 col-md-6">
          <piqet-angular-common-input
            formControlName="phone"
            [control]="myProfileForm.get('phone')"
            label="Phone"
            placeholder="Enter phone number"
            [maxLength]="10"
            [inputType]="'text'"
            (keypressEvent)="onPhoneKeyPress($event)"
            [errorMessages]="{
              required: 'The phone field is required.',
              pattern: 'Please enter valid phone.',
              minlength: 'Please enter valid phone.',
              maxlength: 'Please enter valid phone.'
            }"
          >
          </piqet-angular-common-input>
        </div>
        <div class="form-group col-12 col-md-6">
          <piqet-angular-common-input
            formControlName="postCode"
            [control]="myProfileForm.get('postCode')"
            label="Postcode"
            placeholder="Enter post code"
            [maxLength]="10"
            (keypressEvent)="restrictSpecial($event)"
            [errorMessages]="{
              required: 'The postCode field is required.',
              pattern: 'Please enter valid postCode.',
              minlength: 'Please enter valid postCode.',
              maxlength: 'Please enter valid postCode.'
            }"
          >
          </piqet-angular-common-input>
        </div>
        <div class="form-group col-12 col-md-6">
          <label class="sub-header-drpdown">Country</label>
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            class="personalInputFiled"
            #select
            [items]="countryList"
            [searchable]="false"
            formControlName="country"
            bindLabel="name"
            [searchFn]="commonInputSearch"
            (change)="onChange($event)"
            placeholder="Country*"
            [ngClass]="{ 'is-invalid': submitted }"
            required
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  type="text"
                  class="form-control accordion-search search-input"
                  id="inputValidation"
                  placeholder="Search..."
                  (input)="select.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (myProfileForm.controls['country']?.touched &&
                myProfileForm.controls['country']?.invalid) ||
              myProfileForm.controls['country'].value === 'Country'
            "
            class="input-error"
          >
            Country is required.
          </div>
        </div>
        <div class="form-group col-12 col-md-6">
          <label *ngIf="myProfileForm.controls['state']?.value" class="sub-header-drpdown"
            >State</label
          >
          <ng-select
            [clearable]="true"
            [clearOnBackspace]="false"
            class="personalInputFiled"
            #state
            [items]="getStatesList"
            [searchable]="false"
            formControlName="state"
            bindLabel="name"
            [searchFn]="commonInputSearch"
            placeholder="State"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  (input)="state.filter($any($event.target).value)"
                  type="text"
                  class="form-control accordion-search search-input"
                  id="inputValidation"
                  placeholder="Search..."
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="row">
        <div class="text-margin">
          <button type="submit" class="modelBtn purpleBtnHoverEffect">Save</button>
        </div>
      </div>
    </form>
  </div>
</div>
